// extracted by mini-css-extract-plugin
export default {"container":"a-z","wrapper":"b-z","hideCartCount":"c-z","heading":"d-z","items":"e-z","side":"f-z","checkoutWrapper":"g-z","legal":"h-z","fitNotRecommended":"i-z","fitCallout":"j-z"};